module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_11m.248d56f9.mp3";